<vitamui-common-object-viewer [data]="data" [template]="template" [mode]="mode"></vitamui-common-object-viewer>
